import React from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaInstagram,
  FaGoogle,
  FaWhatsapp,
  FaEnvelope,
  FaFacebookF,
} from "react-icons/fa";

const socialLinks = [
  {
    icon: FaGoogle,
    url: "https://www.google.com/search?q=R+%26+P+Law+Partners",
  },
  {
    icon: FaFacebookF,
    url: "https://www.facebook.com/people/R-P-Law/pfbid02RFedaYHea2QP2Hkf4DK83NhvzLFtBZgTQWpHpwYJTbc6QS5m3juPFwp1mHvTkFFql/",
  },
  {
    icon: FaInstagram,
    url: "https://www.instagram.com/rplawpartners/?hl=en",
  },
];

const ContactDetails = () => {
  // Premium br and colors tailored for a white background theme
  const brandColors = {
    bgWhite: "#FFFFFF",
    blackPrimary: "#1A1A1A",
    textGray: "#4A4A4A",
    crimson: "#A10F1A",
    gold: "#C79A3B",
  };

  return (
    <section className="py-20 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* ADDED HEADING SECTION */}
        <div className="mb-16 text-center flex flex-col items-center">
          <div className="flex items-center gap-3 mb-4">
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(270deg, ${brandColors.crimson}, transparent)`,
              }}
            />
            <span
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "12px",
                letterSpacing: "0.25em",
                color: brandColors.crimson,
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Reach Out To Us
            </span>
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(90deg, ${brandColors.crimson}, transparent)`,
              }}
            />
          </div>
          <h2
            style={{
              fontFamily: "'Cinzel', serif",
              color: brandColors.blackPrimary,
            }}
            className="text-4xl md:text-5xl font-bold uppercase tracking-wide"
          >
            Get In <span style={{ color: brandColors.gold }}>Touch</span>
          </h2>
          <p
            className="mt-4 text-lg font-medium"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: brandColors.textGray,
            }}
          >
            Connect with our expert legal team across our Delhi  and Noida
            chambers.
          </p>
        </div>

        {/* MAIN LAYOUT: Grid splitting Contact Info  and Maps */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* LEFT COLUMN: Contact Information */}
          <div className="flex flex-col gap-8 lg:col-span-1">
            {/* Phone Block */}
            <div className="flex gap-5 items-start">
              <div
                className="p-4 rounded-full bg-white shadow-md border"
                style={{
                  color: brandColors.gold,
                  borderColor: "rgba(199, 154, 59, 0.2)",
                }}
              >
                <FaPhoneAlt size={18} />
              </div>
              <div>
                <h4
                  style={{ color: brandColors.blackPrimary }}
                  className="text-sm font-bold uppercase tracking-wider mb-2"
                >
                  Direct Contact
                </h4>
                <p
                  className="text-lg font-medium leading-relaxed tracking-wide"
                  style={{ color: brandColors.textGray }}
                >
                  +91-7042278441
                  <br />
                  +91-9661900233
                  <br />
                  +91-9953311115
                </p>
              </div>
            </div>

            {/* Email Block */}
            <div className="flex gap-5 items-start">
              <div
                className="p-4 rounded-full bg-white shadow-md border"
                style={{
                  color: brandColors.gold,
                  borderColor: "rgba(199, 154, 59, 0.2)",
                }}
              >
                <FaEnvelope size={18} />
              </div>
              <div>
                <h4
                  style={{ color: brandColors.blackPrimary }}
                  className="text-sm font-bold uppercase tracking-wider mb-2"
                >
                  Email Address
                </h4>
                <p
                  className="text-base font-medium leading-relaxed"
                  style={{ color: brandColors.textGray }}
                >
                  admin@rplawpartners.com
                  <br />
                  ritika@rplawpartners.com
                </p>
              </div>
            </div>

            {/* WhatsApp Button */}
            <a
              href="https://wa.me/919661900233"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 flex items-center justify-center gap-3 p-4 rounded-lg border transition-all duration-300 group shadow-sm hover:shadow-md"
              style={{
                borderColor: brandColors.gold,
                backgroundColor: brandColors.bgWhite,
              }}
            >
              <FaWhatsapp
                size={22}
                className="text-[#25D366] group-hover:scale-110 transition-transform"
              />
              <span
                style={{ color: brandColors.blackPrimary }}
                className="text-sm font-bold tracking-wide uppercase"
              >
                Chat on WhatsApp
              </span>
            </a>

            {/* Social Links */}
            <div className="mt-2">
              <h4
                style={{ color: brandColors.blackPrimary }}
                className="text-xs font-bold uppercase tracking-wider mb-4"
              >
                Follow Us
              </h4>
              <div className="flex gap-4">
                {socialLinks.map(({ icon: Icon, url }, i) => (
                  <a
                    key={i}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full border flex items-center justify-center transition-all duration-300 shadow-sm hover:-translate-y-1"
                    style={{
                      color: brandColors.blackPrimary,
                      borderColor: "rgba(26,26,26,0.1)",
                      backgroundColor: brandColors.bgWhite,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = brandColors.bgWhite;
                      e.currentTarget.style.backgroundColor =
                        brandColors.crimson;
                      e.currentTarget.style.borderColor = brandColors.crimson;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = brandColors.blackPrimary;
                      e.currentTarget.style.backgroundColor =
                        brandColors.bgWhite;
                      e.currentTarget.style.borderColor = "rgba(26,26,26,0.1)";
                    }}
                  >
                    <Icon size={16} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: Office Locations (Maps) */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Delhi Chamber Card */}
            <div
              className="bg-white rounded-xl p-6 border shadow-sm hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group"
              style={{ borderColor: "rgba(26,26,26,0.08)" }}
            >
              <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#A10F1A] to-[#C79A3B] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              <div className="flex gap-4 items-start mb-5">
                <div className="mt-1" style={{ color: brandColors.crimson }}>
                  <FaMapMarkerAlt size={20} />
                </div>
                <div>
                  <h4
                    style={{
                      color: brandColors.blackPrimary,
                      fontFamily: "'Cinzel', serif",
                    }}
                    className="text-xl font-bold uppercase tracking-wide"
                  >
                    Delhi Chamber
                  </h4>
                  <p
                    style={{ color: brandColors.textGray }}
                    className="text-sm leading-relaxed mt-2 font-medium"
                  >
                    Chamber No. 890,
                    <br />
                    Patiala House Court,
                    <br />
                    New Delhi - 110001
                  </p>
                </div>
              </div>
              <div
                className="rounded-lg overflow-hidden border"
                style={{ borderColor: "rgba(26,26,26,0.05)" }}
              >
                <iframe
                  title="Delhi Chamber"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.471171321766!2d77.23238142528845!3d28.61563747567396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2d7333aaaab%3A0x524f269e48a1cfc3!2sChamber%20No-890%2C%20Patiala%20House%20Courts%20Complex%2C%20Patiala%20House%2C%20India%20Gate%2C%20New%20Delhi%2C%20Delhi%20110001!5e0!3m2!1sen!2sin!4v1781260429252!5m2!1sen!2sin"
                  width="100%"
                  height="220"
                  loading="lazy"
                  style={{ border: 0 }}
                />
              </div>
            </div>

            {/* Noida Office Card */}
            <div
              className="bg-white rounded-xl p-6 border shadow-sm hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group"
              style={{ borderColor: "rgba(26,26,26,0.08)" }}
            >
              <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#C79A3B] to-[#A10F1A] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              <div className="flex gap-4 items-start mb-5">
                <div className="mt-1" style={{ color: brandColors.crimson }}>
                  <FaMapMarkerAlt size={20} />
                </div>
                <div>
                  <h4
                    style={{
                      color: brandColors.blackPrimary,
                      fontFamily: "'Cinzel', serif",
                    }}
                    className="text-xl font-bold uppercase tracking-wide"
                  >
                    Noida Office
                  </h4>
                  <p
                    style={{ color: brandColors.textGray }}
                    className="text-sm leading-relaxed mt-2 font-medium"
                  >
                    23/07, Wave One,
                    <br />
                    Sector-18, Noida,
                    <br />
                    Uttar Pradesh - 201301
                  </p>
                </div>
              </div>
              <div
                className="rounded-lg overflow-hidden border"
                style={{ borderColor: "rgba(26,26,26,0.05)" }}
              >
                <iframe
                  title="Noida Office"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.0126292414616!2d77.3207589752866!3d28.5693834756993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce44f4d1b2ae1%3A0xf49003c135d1f106!2sWave%20One%20Noida!5e0!3m2!1sen!2sin!4v1781260506581!5m2!1sen!2sin"
                  width="100%"
                  height="220"
                  loading="lazy"
                  style={{ border: 0 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
